export default __webpack_public_path__ + "static/media/AcornMallFastFood_12.f86e5f73.png";